import { addToChainAfter, Handler } from "@insite/client-framework/HandlerCreator";
import { Cart } from "@insite/client-framework/Services/CartService";
import {
    chain,
    ValidateShippingAddress,
} from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/SetInitialValues";
import { BillToModel, CountryModel, ShipToModel } from "@insite/client-framework/Types/ApiModels";
import { beginCheckout } from "@WhiteCap/Common/Utillities/CustomTracking";
import { extractCategoriesFromPath, getTotalPrice } from "@WhiteCap/Common/Utillities/utils";

type HandlerType = Handler<
    {},
    {
        cart: Cart;
        billTo: BillToModel;
        shipTo: ShipToModel;
        country: CountryModel | undefined;
        shipTos: ShipToModel[];
    }
>;

export const TriggerBeginCheckoutEvent: HandlerType = props => {
    const itemdata = [];
    const categories = extractCategoriesFromPath("");

    if (props.cart?.cartLines && props.cart?.cartLines.length) {
        for (let i = 0; i < props.cart?.cartLines.length; i++) {
            itemdata.push({
                item_id: props.cart?.cartLines[i].erpNumber,
                item_name: props.cart?.cartLines[i].shortDescription,
                item_brand: props.cart?.cartLines[i].brand?.name ? props.cart?.cartLines[i].brand?.name : "",
                item_category: categories[0] || "",
                item_category2: categories[1] || "",
                item_category3: categories[2] || "",
                item_variant: "Standard",
                price: props.cart?.cartLines[i].pricing?.actualPrice,
                discount: 0.0,
                quantity: props.cart?.cartLines[i].qtyOrdered,
            });
        }
    }

    const cartItems =
        props.cart?.cartLines?.map(line => ({
            price: line.pricing?.actualPrice ?? 0,
            quantity: line.qtyOrdered ?? 0,
        })) || [];

    beginCheckout({
        event: "begin_checkout",
        ecommerce: {
            currency: "USD",
            value: getTotalPrice(cartItems),
            coupon: "",
            items: itemdata,
        },
    });
};

addToChainAfter(chain, ValidateShippingAddress, TriggerBeginCheckoutEvent);
